import { render, staticRenderFns } from "./apiMonitoring.vue?vue&type=template&id=72e679a8&"
import script from "./apiMonitoring.vue?vue&type=script&lang=ts&"
export * from "./apiMonitoring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports